export default __webpack_public_path__ + "static/media/hootsuite.b9dbbb2a.svg";